import { Breadcrumbs } from "components/breadcrumbs";
import { EditAccountForm } from "./components/editAccountForm";
import { useOne, useParse } from "@refinedev/core";
import { IOrgAccountDetail } from "interfaces";
import { FullScreenLoading } from "components/fullScreenLoading";

export const EditOrgAccount : React.FC = () => {

  const parse = useParse();
  const { params } = parse();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IOrgAccountDetail>({
    resource: "organization/account",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const orgAccountDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Org's Account" />
      {orgAccountDetailData ? <EditAccountForm defaultAccountData={orgAccountDetailData} id={params?.id} /> : <></>}
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}